// requires async function with state update when using

const getGrowthbookUrl = async () => {
    try {
      const response = await fetch('/paths/paths.json');
      const data = await response.json();

      return data.urls.growthBookUrl
  } catch (error) {
    console.error('Error fetching or parsing JSON:', error);
  }}
  
  export default getGrowthbookUrl
  